import { useState } from "react";
import axios from "axios";

export default function CreateSingleUser() {

  const API_BASE = "https://api.ilogically.com/api";
  const APP_TOKEN = "87adfacc2dffc65ae172d59a9f0badda";

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    userEmail: "",
    userPassword: "",
    role: "student"
  });

  const [message, setMessage] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {

    try {

      const res = await axios.post(
        `${API_BASE}/users/create`,
        form,
        { params: { appToken: APP_TOKEN } }
      );

      setMessage("User created successfully");
      setForm({
        firstName: "",
        lastName: "",
        userEmail: "",
        userPassword: "",
        role: "student"
      });

    } catch (err) {
      setMessage("Error creating user");
    }
  };

  return (
    <div>

      <input name="firstName" placeholder="First Name" value={form.firstName} onChange={handleChange} />
      <input name="lastName" placeholder="Last Name" value={form.lastName} onChange={handleChange} />
      <input name="userEmail" placeholder="Email" value={form.userEmail} onChange={handleChange} />
      <input name="userPassword" placeholder="Password" value={form.userPassword} onChange={handleChange} />

      <select name="role" value={form.role} onChange={handleChange}>
        <option value="student">Student</option>
        <option value="teacher">Teacher</option>
        <option value="staff">Staff</option>
      </select>

      <button onClick={handleSubmit}>Create User</button>

      {message && <p>{message}</p>}

    </div>
  );
}